import { mergeProps } from '@react-aria/utils';
import { useSelectAutocompleteContext } from '../../SelectAutocomplete/hooks/useSelectAutocompleteContext.js';
import { useSelectContext } from '../../../hooks/useSelectContext.js';

var useSelectListBox = function useSelectListBox(props) {
  var _useSelectContext = useSelectContext(),
    menuProps = _useSelectContext.menuProps,
    state = _useSelectContext.state,
    listBoxSettings = _useSelectContext.listBoxSettings;
  var _useSelectAutocomplet = useSelectAutocompleteContext(),
    collectionRef = _useSelectAutocomplet.collectionRef;

  // For single selection Select, close Popover when selection changes
  var onSelectionChange = function onSelectionChange(_) {
    if ((listBoxSettings === null || listBoxSettings === void 0 ? void 0 : listBoxSettings.selectionMode) === 'single') {
      state === null || state === void 0 || state.close();
    }
  };
  return {
    selectionListBoxProps: mergeProps(listBoxSettings, menuProps, {
      disableClearOnEsc: true,
      onSelectionChange: onSelectionChange
    }, props, state),
    selectionListBoxRef: collectionRef
  };
};

export { useSelectListBox };
//# sourceMappingURL=useSelectListBox.js.map
